"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listMonths = void 0;
var fdatetime_1 = require("./fdatetime");
var padNumber_1 = require("./padNumber");
var datePart_1 = require("./datePart");
/**
 * Zwraca tablicę zawierającą listę miesięcy pomiędzy datami
 * @param startDate data początkowa
 * @param endDate data końcowa
 * @param format format, domyślnie MMMM yyyy, czyli "styczeń 2019"
 */
function listMonths(startDate, endDate, format /* = 'MMMM yyyy'*/) {
    var m1 = (0, datePart_1.default)(startDate, 'M');
    var y1 = (0, datePart_1.default)(startDate, 'y');
    var m2 = (0, datePart_1.default)(endDate, 'M');
    var y2 = (0, datePart_1.default)(endDate, 'y');
    var result = [];
    if (m1 && y1 && m2 && y2) {
        m1--;
        m2--;
        var ys_1 = ' ' + y1;
        var func = void 0;
        switch (format) {
            case 'MMMM yyyy':
                func = function (m, y) { return fdatetime_1.monthNames[m] + ys_1; };
                break;
            case 'MMM yyyy':
                func = function (m, y) { return fdatetime_1.monthShort[m] + ys_1; };
                break;
            case 'MM yyyy':
                func = function (m, y) { return (0, padNumber_1.default)(m + 1) + ys_1; };
                break;
            case 'M yyyy':
                func = function (m, y) { return m + 1 + ys_1; };
                break;
            case 'MMMM':
                func = function (m, y) { return fdatetime_1.monthNames[m]; };
                break;
            case 'MMM':
                func = function (m, y) { return fdatetime_1.monthShort[m]; };
                break;
            case 'MM':
                func = function (m, y) { return (0, padNumber_1.default)(m + 1); };
                break;
            case 'M':
                func = function (m, y) { return (m + 1).toString(); };
                break;
            default:
                func = function (m, y) { return fdatetime_1.monthNames[m] + ys_1; };
                break;
        }
        while ((m1 <= m2 && y1 === y2) || y1 < y2) {
            result.push(func(m1, y1));
            m1++;
            if (m1 > 11) {
                m1 = 0;
                y1++;
                ys_1 = ' ' + y1;
            }
        }
    }
    return result;
}
exports.listMonths = listMonths;
exports.default = listMonths;
//# sourceMappingURL=listMonths.js.map